<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <FilterBar surface="photoTagging" :initial-filter="photoFilters" @apply-filters="setPhotoFilters($event)"></FilterBar>
      </v-col>
    </v-row>

    <!-- Mass Apply Tags -->
    <v-row class="border--primary">
      <v-col cols="6">
        <v-row align="end">
          <v-col cols="6" align-self='end'>

            <!--- Tag Categories -->
            <v-autocomplete
                v-model="selectedCategory"
                :items="allCats"
                :value="allCats[0].id"
                class="mt-4"
                item-text="name"
                item-value="id"
                label="Category"
            />
          </v-col>

          <!--- Tags List -->
          <v-col cols="6">
            <v-autocomplete
                v-model="selectedTags"
                :items="filteredTags"
                :search-input.sync="tagSearchInput"
                chips
                class="mt-4"
                item-text="name"
                item-value="id"
                label="Tags"
                multiple
                return-object
                @change="tagSearchInput=''"
            >
              <template v-slot:selection="data">
                <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    small
                    @click="data.select"
                    @click:close="removeTagFromList(data.item)"
                >
                  <div style="overflow: hidden"> {{ data.item.name }}</div>
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.category.name"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
      <v-col align-self="start" cols="5" display="flex" justify-content="flex-start">
        <small class="text-xl-left font-weight-300 mb-3">Tags to Apply</small>
        <v-chip-group active-class="primary--text" column>
          <v-chip
              v-for="tag in selectedTags"
              :key="tag.id" close
              color="primary"
              @click:close="removeTagFromList(tag)"
          >
            <div style="overflow: hidden">{{ tag.name }}</div> &nbsp;
          </v-chip>
        </v-chip-group>
      </v-col>

      <v-col align-self="center" cols="1">
        <v-btn class="mr-2" color="primary" @click="massApplyTag">
          Apply
        </v-btn>
      </v-col>
    </v-row>


<!--    <v-row class="p-5">-->
    <PhotoListView :images="photos" :isQc="false" :isSa="false"/>
<!--    </v-row>-->

    <v-container class=" fixed border--primary">

      <v-btn
          class="mr-2 float-right"
          color="success"
          @click="submitBatch({getNext: true})">Submit & get Next Batch
      </v-btn>
      <v-btn
          class="mr-2 float-right"
          color="primary"
          @click="submitBatch({getNext: false})">Submit & Close
      </v-btn>
    </v-container>

  </v-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import FilterBar from "@/components/filters/FilterBar.vue";
import {routeFilterSeed} from '@/components/filters/routeSeed'
import PhotoListView from '../components/PhotoListView'

export default {
  name: 'PhotoTagging',
  components: {
    PhotoListView,
    FilterBar
  },
  data() {
    return {
      selectedTags: [],
      selectedCategory: 0,
      tagSearchInput: '',
      photoFilters: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        onlyUntagged: true,
        includePartiallyTagged: true,
        includeInactive: false,
        respIdSearchFreeForm: null,
        country: null,
        retailer: null,
        department: null
      },
      dialog: {
        modal: false
      }
    }
  },
  // Quick-link deep links (routeSeed.js) must seed the filter in created(),
  // BEFORE the filter child mounts: Vue 2 mounts the child before the parent,
  // so seeding in the parent's mounted() lands after the child has snapshotted
  // initialFilter — leaving the Applied-Filters chips blank and dropping the
  // scope on the next Apply. created() runs first, so the child snapshots the
  // seeded filter. Matches BoxTagging's timing.
  created() {
    this.photoFilters = {...this.photoFilters, ...routeFilterSeed(this.$route)}
  },
  mounted() {
    this.getPhotosByFilter(this.photoFilters)
  },
  computed: {
    ...mapState({
      photos: state => state.photos.photos,
    }),
    // IT-704 (P4): the pick lists read the visible getters so machine-owned
    // (derived) categories and their tags disappear once derivation is enabled.
    ...mapGetters(['visibleCategories', 'visibleTags', 'retainHumanTags']),
    allCats() {
      var cats = this.visibleCategories
      cats = cats.map(cat => ({id: cat.id, name: cat.name}))
      cats.unshift({id: 0, name: 'All'})
      return cats
    },
    filteredTags() {
      let categId = parseInt(this.selectedCategory)
      if (categId > 0) {
        return this.visibleTags.filter(tag => tag.category.id === categId)
      } else {
        return this.visibleTags
      }
    }

  },
  methods: {
    ...mapActions(['bulkUpdate', 'getPhotosByFilter', 'submitAssigned']),
    ...mapMutations(['setMessage', 'setPhotos']),

    categorySelected(e) {
      this.selectedCategory = e

    },
    removeTagFromList(tag) {
      let index = this.selectedTags.indexOf(tag)
      if (index >= 0) this.selectedTags.splice(index, 1)
    },
    setPhotoFilters(newPhotoFilter) {
      this.photoFilters = newPhotoFilter;
      this.getPhotosByFilter(this.photoFilters);
    },
    submitBatch(payload) {
      let self = this
      this.submitAssigned().then(() => {
        self.setMessage({
          text: 'Photos Tagged',
          type: 'success',
          alert: true
        })
        self.setPhotos([])
        if (payload.getNext) {
          self.getPhotosByFilter(this.photoFilters);
        }
      })
    },
    massApplyTag() {
      let selectedPhotos = this.photos.filter(photo => photo.selected)
      let self = this
      let selectedTagIds = this.selectedTags.map(tag => tag.id)

      if (selectedTagIds.length < 1) {
        let message = {
          text: 'No Tags Selected',
          type: 'success',
          alert: true
        }
        this.setMessage(message)
        return
      }

      selectedPhotos.forEach(photo => {
        // IT-704 (P4): when derivation is on, don't echo the photo's derived
        // tags back — the backend recomputes them from the human set.
        let currPhotoTagsIds = this.retainHumanTags(photo.tags).map(tag => tag.id)
        let combinedTagsIds = selectedTagIds.concat(currPhotoTagsIds)
        let payload = {
          selected_photos: [photo.id],
          selected_tags: combinedTagsIds,
          isQc: false,
          needs_review: photo.needsReview
        }
        this.bulkUpdate(payload).then(() => {
          let message = {
            text: 'Photos Tagged Successfully',
            type: 'success',
            alert: true
          }
          this.setMessage(message)
        })
      })// end foreach

    },
  }
}
</script>


<style scoped>
.border--primary {
  border: 1px solid #666;
  border-radius: 4px;
  padding: 10px;
}

.fixed {
  position: fixed !important;
  bottom: 0 !important;
  font-size: 40px;
  /* margin:auto; */
  z-index: 999;
  background: white;

}

.v-chip .v-chip__content {
  height: auto !important;
}

.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
</style>
